import Vue from 'vue'
import Meta from 'vue-meta'
import routes from './routes'
import Router from 'vue-router'
import store from '../store'
//import { sync } from 'vuex-router-sync'

Vue.use(Meta);
Vue.use(Router);


const router = createRouter();

//sync(store, router)

export default router

function createRouter () {
    const router = new Router({
        mode: 'history',
        routes
    });
    router.beforeEach(beforeEach);
    router.afterEach(afterEach);
    return router
}
async function beforeEach (to, from, next) {

    if (to == "") {
        return next();
    }
    await store.dispatch('auth/fetchUser');

    let isAuthenticated = store.getters['auth/authenticated'];
  
    if (to.meta.requiresAuth && isAuthenticated === false) {        
        next('/login?redirect=' + from.path);
    }

    if (!to.meta.requiresAuth && !to.meta.public && isAuthenticated === true) {        
        next('/dashboard');
    }

    next();
}

async function afterEach (to, from, next) {
    if (to == "") {
        return next();
    }
    await router.app.$nextTick()
}